export default "__VITE_PUBLIC_ASSET__3dbd46b0__"